import { render, staticRenderFns } from "./Ys-Map.vue?vue&type=template&id=37369a83&scoped=true"
import script from "./Ys-Map.vue?vue&type=script&lang=js"
export * from "./Ys-Map.vue?vue&type=script&lang=js"
import style0 from "./Ys-Map.vue?vue&type=style&index=0&id=37369a83&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37369a83",
  null
  
)

export default component.exports